import spritemap from "@milestone-sys/web-design-system/msds-spritemap.svg";
import "./select.scss";
import { useEffect, useState } from "react";
import { SelectionTypes } from "../../../lib/enums";

const Select = ({
    id,
    options,
    defaultOption,
    initialValue,
    handleDataChange,
    isSmall,
    className,
    isDisabled,
    selectionType
}: SelectProps) => {
    const [value, setValue] = useState<string>(initialValue ?? '');

    // Convert options object to array if it's not already an array   
    let optionArray = [];

    if (Array.isArray(options)) {
        optionArray = options;
    } else if (options) {
        optionArray = Object.entries(options).map(([value, label]) => ({ value, label }));
    }

    const optionElements = optionArray.map((opt) => {
        return (
            <option key={opt.label} value={opt.value}>
                {opt.label}
            </option>
        );
    });

    useEffect(() => {
        if (initialValue) {
            setValue(initialValue)
        }
    }, [initialValue]);

    const handleSelectChange = (value) => {

        //Convert the value to number when needed
        let selectionValue = value;        
        if (selectionType && selectionType !== SelectionTypes.Text && value && value.length > 0) {
            if (selectionType === SelectionTypes.Number && !isNaN(value)) {
                selectionValue = parseInt(value);
            }            
            if (selectionType === SelectionTypes.Boolean) {                
                selectionValue = value.toLowerCase() === "true" ? true : false; 
            }
        }
        
        setValue(selectionValue)
        handleDataChange(selectionValue)
    }

    return (
        <div className={`${className ? className : ''}`}>
            {defaultOption?.label && (
                <label className="msds-text-body-2 msds-text-gray-10 d-block mb-3">{defaultOption?.label}</label>
            )}            
            <div className='msds-select-input'>
                <select
                    id={id}
                    value={value}
                    autoComplete="no"
                    className={`msds-select-input__select ${isSmall ? 'msds-select-input__select--small' : ''}`}
                    onChange={(e) => handleSelectChange(e.target.value)}
                    disabled={isDisabled}
                >
                    {optionElements}
                </select>
                <div className="msds-select-input__icon">
                    <svg>
                        <use href={`${spritemap}#right-arrow`} />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default Select;

type SelectProps = {
    id?: string;
    options?: { [key: string]: string | number } | { label: string; value: string | number }[];
    defaultOption?: { label: string; value: string };
    initialValue?: string;
    handleDataChange?: (newValue: any) => void;
    isSmall?: boolean;
    className?: string;
    isDisabled?: boolean;
    selectionType?: SelectionTypes;
};